import { Link } from "react-router-dom";
import { ASSETS } from "@/i18n";
import { OdyneCredit } from "@/components/OdyneCredit";

/** Two-column auth layout: form on the left, AURA brand panel on the right. */
export const AuthShell = ({ title, subtitle, children, footer, testId }) => (
  <div data-testid={testId} className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAFA]">
    <div className="flex flex-col px-6 md:px-12 py-10 md:py-14 max-w-xl w-full mx-auto justify-between">
      <Link to="/" data-testid="auth-logo-link" className="inline-flex items-center gap-3 w-fit">
        <img
          src={ASSETS.logo}
          alt="AURA"
          className="h-11 w-11 rounded-full object-contain bg-white ring-1 ring-black/5"
          style={{ mixBlendMode: "multiply" }}
        />
        <div className="leading-tight">
          <div className="font-serif text-2xl tracking-tight text-[#1A1A1A]">AURA</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#737373]">CRM · 2026</div>
        </div>
      </Link>

      <div className="flex-1 flex flex-col justify-center py-12">
        <div className="text-[11px] tracking-[0.3em] uppercase text-[#A78BFA] mb-4">{subtitle}</div>
        <h1 className="font-serif font-light text-4xl md:text-5xl leading-[1.05] tracking-tight text-[#1A1A1A]">
          {title}
        </h1>
        <div className="mt-9">{children}</div>
      </div>

      <div>
        <div className="text-sm text-[#737373] font-light">{footer}</div>
        {/* I documenti legali devono restare raggiungibili anche fuori dalla
            landing: chi arriva direttamente al login non vede mai il footer. */}
        <div className="mt-5 flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-[#A3A3A3]">
          <Link to="/privacy" className="hover:text-[#737373]">Privacy</Link>
          <Link to="/cookie-policy" className="hover:text-[#737373]">Cookie</Link>
          <Link to="/termini" className="hover:text-[#737373]">Termini</Link>
          <Link to="/note-legali" className="hover:text-[#737373]">Note legali</Link>
        </div>
        <OdyneCredit className="mt-4" />
      </div>
    </div>

    {/* Brand panel */}
    <div className="hidden lg:block relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(135deg, #F5F0FF 0%, #FFF5F5 50%, #ECFEFF 100%)",
        }}
      />
      <div
        aria-hidden
        className="absolute -top-40 -right-40 h-[36rem] w-[36rem] rounded-full blur-3xl opacity-60 animate-blob"
        style={{ background: "radial-gradient(circle, #C4B5FD 0%, transparent 70%)" }}
      />
      <div
        aria-hidden
        className="absolute -bottom-40 -left-40 h-[34rem] w-[34rem] rounded-full blur-3xl opacity-50 animate-blob-slow"
        style={{ background: "radial-gradient(circle, #67E8F9 0%, transparent 70%)" }}
      />

      <div className="relative h-full flex flex-col items-center justify-center px-12 text-center">
        <img
          src={ASSETS.logo}
          alt=""
          className="h-40 w-40 rounded-full object-contain animate-float"
          style={{ mixBlendMode: "multiply" }}
        />
        <h2 className="mt-8 font-serif font-light text-5xl text-[#1A1A1A] tracking-tight leading-tight max-w-md">
          L'aura del tuo <span className="italic">salone,</span>{" "}
          <span className="shimmer-text">amplificata.</span>
        </h2>
        <p className="mt-5 text-[#4A4A4A] font-light max-w-sm leading-relaxed">
          Accedi alla web-app AURA per gestire prenotazioni, clienti e fidelity card.
        </p>
      </div>
    </div>
  </div>
);
